/* eslint-disable no-unused-vars */
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import LabelInput from "../../common/LabelInput";
import Body from "../../components/Body";
import { AiFillCalendar } from "react-icons/ai";
import { BiHash } from "react-icons/bi";
import config from "../../config/config";
import colors from "../../config/colors";
import DetailBlock from "../../common/DetailBlock";
import AppButton from "../../common/AppButton";
import Dropzone from "../../common/Dropzone";
import api from "../../config/api";
import LabelText from "../../common/LabelText";
import focusInputByName from "../../common/focusInputByName";
import AppInput from "../../common/AppInput";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

const size = config.iconSize;

const formInit = {
  jobId: "A2Z001",
  organization: "",
  poRequestLocation: "",
  poReceivedDate: new Date(),
  files: [],
  poNo: "",
};

export default function ReceivePO() {
  const { organization_id, job } = useParams();
  const location = useLocation();
  const { data: init } = location.state;
  const [disabled, setDisabled] = useState(false);
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [form, setForm] = useState(
    cloneDeep({
      ...formInit,
      organization: init.organizationName,
      poRequestLocation: init.poRequestLocation,
    })
  );

  const handleSubmit = async (event) => {
    event.preventDefault();

    const images = form.files;
    delete form.files;

    if (!form.poNo) return focusInputByName("poNo");
    if (!images) return toast.error("Please Select a file to submit...");

    setDisabled(true);
    setUploading(true);

    const res = await api.post("/po", {
      ...form,
      organization: organization_id,
      job,
    });

    if (!res.ok) {
      setDisabled(false);
      return toast.error(res.originalError.message);
    }

    const formData = new FormData();
    for (let i = 0; i < images.length; i++) {
      formData.append("files", images[i]);
    }

    const uploadRes = await api.post("/upload-files", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    const urls = uploadRes.data.urls;

    const done = await api.put("/po", { _id: res.data._id, files: urls });

    if (!done.ok) {
      setDisabled(false);
      return toast.error(done.originalError.message);
    }

    queryClient.invalidateQueries(["pos"]);
    toast.success("PO has been successfully received.");
    setDisabled(false);
    navigate(-1);
  };

  const handleChange = ({ target }) => {
    const name = target.name;
    const value = target.value;
    setForm({ ...form, [name]: value });
  };

  const { jobId, organization, poRequestLocation, poReceivedDate, poNo } = form;

  return (
    <Body back title="Receive PO">
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          <DetailBlock
            style={{
              width: "100%",
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <div className="d-flex justify-content-center">
              <div
                className="d-flex"
                style={{
                  width: 800,
                  flexWrap: "wrap",
                  gap: "0px 20px",
                  justifyContent: "space-between",
                  marginBottom: 30,
                }}
              >
                <LabelText
                  name="jobId"
                  label="Job ID"
                  value={init.jobId}
                  columnMode
                />
                <LabelText
                  label="Organization"
                  value={organization}
                  columnMode
                />
                <LabelText
                  label="PO Request Location"
                  value={poRequestLocation}
                  columnMode
                />
              </div>
            </div>
          </DetailBlock>

          <DetailBlock style={{ width: "100%" }}>
            <div className="d-flex justify-content-center">
              <div
                className="d-flex"
                style={{
                  width: 800,
                  flexWrap: "wrap",
                  gap: "0px 20px",
                  alignItems: "flex-end",
                  marginBottom: 30,
                }}
              >
                <div className="d-flex" style={{ gap: 30 }}>
                  <AppInput
                    label="Received Date"
                    onChange={handleChange}
                    name="poReceivedDate"
                    type="date"
                    value={poReceivedDate}
                    required
                    leftIcon={
                      <AiFillCalendar
                        color={colors.silver}
                        size={config.iconSize}
                      />
                    }
                    floatLabel
                  />
                  <AppInput
                    label="PO No"
                    onChange={handleChange}
                    name="poNo"
                    value={poNo}
                    required
                    leftIcon={<BiHash color={colors.silver} size={size} />}
                    // style={{ marginBottom: 10 }}
                    type="text"
                    floatLabel
                  />
                </div>
                {/* <Dropzone
                  onChange={(files) => {
                    setForm({ ...form, files });
                  }}
                /> */}
              </div>
            </div>
          </DetailBlock>
        </div>
        <div style={{ margin: "20px 0px" }}>
          {!uploading && (
            <AppButton
              disabled={disabled}
              type="submit"
              onClick={handleSubmit}
              text="Receive"
              className="btn-primary"
            />
          )}
          {uploading && (
            <div className="alert alert-warning">
              <strong>Please Wait!</strong> Your files are being saved !
            </div>
          )}
        </div>
      </form>
    </Body>
  );
}
